<template>
    <div class="add_other_users">
        <div>
            <h3>新增其他租戶資料</h3>
            <div class="other_users">
                <div>
                    <div class="other_users_name">
                        <label>
                            姓名：
                            <input type="text" v-model="other_user_name">
                        </label>
                    </div>
                    <div class="other_users_phone">
                        <label>
                            電話：
                            <input type="text" v-model="other_user_phone">
                        </label>
                    </div>
                </div>
                <div class="buttons">
                    <button class="subscribed_y" @click="add_other_users">
                        新增
                    </button>
                    <button class="subscribed_y" @click="cancel">
                        取消
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/css/member/addOtherUsers.css";

export default {
    name: 'AddOtherUsers',
    data() {
        return {
            other_user_name: '',
            other_user_phone: '',
            house_number: localStorage.getItem('house_number')
        };
    },
    components: {

    },
    filters: {},
    beforeMount: function () {

    },
    methods: {
        add_other_users () {
            console.log(123);
            if (this.other_user_name == '' || this.other_user_phone == '') {
                alert('請填入相關資料');
            } else {
                const formData = new FormData();
                formData.append('CMD' , 'FrontMemberHomeAddOtherUsers');
                formData.append('other_user_name' , this.other_user_name);
                formData.append('other_user_phone' , this.other_user_phone);
                formData.append('house_number' , this.house_number);
                this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
                .then(response => {
                    // console.log(response);
                    if (response.data.result == true) {
                        alert('新增成功');
                        this.$router.push({ name: 'MemberHome'});
                    } else {
                        alert(response.data.error);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        cancel () {
            this.$router.push({ name: 'MemberHome'});
        }
    },
    mounted: function () {},
};
</script>

<style>

</style>
